import React, { useState } from 'react';

import { useDisclosure } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';

import { getters } from 'constants/table';
import FormModal from 'containers/FormModal';
import { parseDefaultValue } from 'utils/parsers';

export const useFormModal = (content: string) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [updateId, setUpdateId] = useState<number>();
  const [defaultValues, setDefaultValues] = useState<any>();

  function parseDefaultValues(data) {
    const values = {};
    Object.entries(data).forEach(([key, value]) => {
      values[key] = parseDefaultValue(key, value, content);
    });
    setDefaultValues(values);
  }

  const { isLoading } = useQuery(['form', 'modal', content, updateId], () => {
    if (updateId) {
      return getters[content]({ id: updateId });
    }
    throw new Error('No id');
  }, {
    enabled: !!updateId,
    cacheTime: 0,
    onSuccess: ({ data }) => parseDefaultValues(data)
    ,
  });
  const Form = ({ onSuccess = () => null }) => (
    <FormModal
      isFetching={isLoading}
      action={!isEmpty(defaultValues) ? 'Editar' : 'Novo'}
      content={content}
      isOpen={isOpen}
      onClose={onClose}
      defaultValues={defaultValues}
      onSuccess={() => {
        onSuccess();
        setUpdateId(undefined);
      }}
    />
  );

  return {
    isOpen, onClose, onOpen, Form, setUpdateId, setDefaultValues: parseDefaultValues,
  };
};
